import './LegendLeaflet.css';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

export const getLegendLeaflet = (posicao_legenda:string, titulo_legenda:string,categorias_legenda:Array<string>,cores_legenda:Array<string>) => {
   // @ts-ignore
   let legenda_mapa = L.control({ position: posicao_legenda });
   let rotulos = [`<strong>${titulo_legenda}</strong>`];
   legenda_mapa.onAdd = function () {
        let div = L.DomUtil.create('div', 'info legend');

        for (var i = 0; i < categorias_legenda.length; i++) {
            div.innerHTML += 
            rotulos.push(
                '<i style="background:' + cores_legenda[i] + '"></i> ' +
            (categorias_legenda[i] ? categorias_legenda[i] : '+'));
        }
        div.innerHTML = rotulos.join('<br>');
        return div;
    };
    return legenda_mapa;
}